const startTimer = (timerId, duration, setTime) => {
    const STORAGE_KEY = `walletTimer_${timerId}`;

    const savedTimer = localStorage.getItem(STORAGE_KEY);
    let startTime = Date.now();
    let remaining = duration;

    if (savedTimer) {
        const { startTime: savedStartTime, duration: savedDuration } = JSON.parse(savedTimer);
        const elapsed = Math.floor((Date.now() - savedStartTime) / 1000);
        remaining = Math.max(0, savedDuration - elapsed);
        startTime = savedStartTime;
        console.log(`Restored timer ${timerId}:`, { startTime, duration: savedDuration, remaining });
    } else {
        localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
                startTime,
                duration,
            })
        );
        console.log(`Started new timer ${timerId}:`, { startTime, duration });
    }

    setTime(remaining);

    const interval = setInterval(() => {
        remaining = Math.max(0, remaining - 1);
        setTime(remaining);

        if (remaining <= 0) {
            if (timerId === 'secondTimer') {
                // Для второго таймера: рестарт вместо очистки
                localStorage.setItem(
                    STORAGE_KEY,
                    JSON.stringify({
                        startTime: Date.now(),
                        duration,
                    })
                );
                setTime(duration);
                console.log(`Second timer ${timerId} restarted with duration: ${duration}`);
            } else {
                clearInterval(interval);
                localStorage.removeItem(STORAGE_KEY);
                console.log(`Timer ${timerId} finished`);
            }
        }
    }, 1000);

    const stopTimer = () => {
        clearInterval(interval);
        localStorage.removeItem(STORAGE_KEY);
        setTime(0);
        console.log(`Timer ${timerId} stopped`);
    };

    return stopTimer;
};

const formatTime = (seconds) => {
    if (seconds === null || seconds === undefined) return '00:00'; // Изменено для второго таймера
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export { startTimer, formatTime };